import { isMobile, isSafari } from './_other'
import { relateGenerate } from './_generator.js';

let last_known_scroll_position = 0;
let ticking = false;
let moveIndex = 0;
let nowIndex = 0;

let paralist = document.querySelectorAll('.move-window')
let aboveHeight = document.querySelector('.aboveHeight').getBoundingClientRect()
let notice = document.getElementById('notice').getBoundingClientRect()
let navlist = document.querySelector('.navigation').childNodes
let navmblist = document.querySelector('.navigationMobile').childNodes
let tempMoveOffset = [];
let tempNavOffset = [];
let moveOffset = [];
let navOffset = [];
let navDom = [];
let navmbDOM = [];

//parallax move
for(let value of paralist) {
    tempMoveOffset.push(value.offsetTop)
    tempNavOffset.push(value.offsetTop)
}
let drillBottom;
if(window.innerWidth>800){
    drillBottom = notice.top + (window.innerHeight*0.4)
}else{
    if(isSafari()){
        drillBottom = notice.top + (window.innerHeight) + 100
    }else{
        drillBottom = notice.top + (window.innerHeight) + 20
    }
   
}

tempNavOffset.splice(5,1,drillBottom)
console.log(tempNavOffset)
console.log(notice)


if(window.innerWidth>800) {
    //slideUp
    moveOffset = tempMoveOffset.map((el,index)=>{
        return el - (window.innerHeight*0.7)
    })
    //nav pos
    navOffset = tempNavOffset.map((el,index)=>{
        let value;
        if(index<=1) {
            value = el-200
        }else{
            value = el-190
        }
        return value
    })
}else{
    //slideUp
    moveOffset = tempMoveOffset.map((el,index)=>{
        let value;
        if(index<=1){
            value = el - (window.innerHeight*0.8)
        }else{
            value = el - (window.innerHeight*0.5)
        }
        return value
    })

    //nav pos
    if(isSafari()){
        //iPhone
        navOffset = tempNavOffset.map((el,index)=>{
            let value;
            if(index<=1) {
                value = el-40
            }else if(index>=2 && index<5){
                value = el-60
            }else{
                value = el-90
            }
            return value
        })
    }else {
        //android
        navOffset = tempNavOffset.map((el,index)=>{
            let value;
            if(index<=1) {
                value = el-30
            }else{
                value = el-30
            }
            return value
        })

        
    }
}

//navigation
for(let value of navlist) {
    if(value.tagName === 'DIV'){
        navDom.push(value)
    }
}

//navigationMobile
for(let value of navmblist) {
    if(value.tagName === 'DIV'){
        navmbDOM.push(value)
    }
}

//navigation PC
let aryNaviPC = document.querySelector('.navigation').childNodes;
let aryPC = Array.from(aryNaviPC).filter(el=>el.tagName === 'DIV')


// console.log(moveOffset)
// console.log(navOffset)

function mainScrollFunc(scrollpos){
    // console.log(scrollpos)

    

    //moveUP pos
    moveOffset.forEach(function (value,i) {
        if(i>=0) {
            if(i>moveOffset.length-2){
                if(scrollpos>moveOffset[i]){
                    moveIndex = i;
                }
            }else{
                if(scrollpos>moveOffset[i] && scrollpos <= moveOffset[i+1]){
                    moveIndex = i;
                }
            }
        }
    })

    //navigation pos
    navOffset.forEach(function (value,i) {
        if(i>=0) {
            if(i>navOffset.length-2){
                if(scrollpos>navOffset[i]){
                    nowIndex = i;
                }
            }else{
                if(scrollpos>navOffset[i] && scrollpos <= navOffset[i+1]){
                    nowIndex = i;
                }
            }
        }
    })

    
    paralist.forEach((el,index)=>{
        if (moveIndex >= index) {
            el.classList.add('moveUP')
        } else {
            el.classList.remove('moveUP')
        }
    })
    navDom.forEach((el,index)=>{
        if (nowIndex > 0 && nowIndex === index+1) {
            el.classList.add('active')
        } else {
            el.classList.remove('active')
        }
    })

    // console.log('moveIndex:'+moveIndex)
    // console.log('nowIndex:'+nowIndex)


    //change menu
    if(window.innerWidth<800) {
        //change header
        let changePoint = document.getElementById('changePoint').offsetTop - 200
        if(scrollpos >= changePoint) {
            document.body.classList.add('changeHeader')
        }else{
            document.body.classList.remove('changeHeader')
        }

        //navigationMobile
        navmbDOM.forEach((el,index)=>{
            if (nowIndex > 0 && nowIndex === index+1) {
                el.classList.add('active')
            } else {
                el.classList.remove('active')
            }
        })
        //mobile menu click
    }
}

function updatePosition(){
    last_known_scroll_position = window.scrollY || window.pageYOffset;
    if (!ticking) {
        window.requestAnimationFrame(function() {
            mainScrollFunc(last_known_scroll_position);
            ticking = true;
        });
    }
    ticking = false;
}
var throttled = _.throttle(updatePosition, 0);
window.addEventListener('scroll', throttled);



/* navigation click scroll */
document.querySelector('.navigation').addEventListener('click',function(e){
    let targetIndex = aryPC.findIndex(el=>{
        return el === e.target
    })
    // console.log(targetIndex)
    window.scrollTo({
        top: navOffset[targetIndex+1]+10,
        behavior: "smooth"
    })

})


/* navigationMobile click scroll */
window.__forceSmoothScrollPolyfill__ = true;
document.querySelector('.navigationMobile').addEventListener('click',function(e){
    let targetIndex = navmbDOM.findIndex(el=>{
        return el === e.target
    })
    // console.log("targetIndex:"+targetIndex)
    // console.log("scroll top:"+navOffset[targetIndex+1])

    window.scrollTo({
        top: navOffset[targetIndex+1]+20,
        behavior: "smooth"
    })

})




/*================================
相關新聞
================================*/
//localhost運行proxy
//上線前記得換正式站api  https://www.cna.com.tw/cna2018api/api/ProjTopic
//傳demo站用test.json
let bodydata ={
    "tno": "3568",		
	"pageidx":"1",	
	"pagesize":"10"	
}
let p1 = fetch('https://www.cna.com.tw/cna2018api/api/ProjTopic',{
    method: 'POST',
    body: JSON.stringify(bodydata),
    headers: new Headers({
        'Content-Type': 'application/json'
    })
})
// let p1 = fetch('api/test.json')
Promise.all([p1])
    .then(responses => Promise.all(responses.map(r => r.json())))
    .then(res => {

        let data = res[0].ResultData.Items.filter((el,index)=>index<6)
        // console.log(data)

        let relateHTML = relateGenerate(data)
        document.getElementById('related_1').innerHTML = relateHTML;
    })
    .catch((err) => {
        console.log(err);
    });









